module.exports = __webpack_public_path__ + "img/base_activites_grande_roue.b9613677.svg";